import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class EditDriver extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			vno : '',
			dname : '',
			preaddr : '',
			peraddr : '',
			dob : '',
			mob : '',
			licno : '',
			posts : [],
			vehi : [],
			 _redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.vno && this.state.dname && this.state.peraddr && this.state.dob && this.state.mob && this.state.licno){
			console.log(this.state);
			PostData('transport/updatedriver',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Driver Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					document.getElementById("eddriform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getdetails();
		this.getvehicleno();
	}
	
	getdetails(){
		
		GetData('transport/getdriverbyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					vno : res[0]['vehicleno'],
					dname : res[0]['name'],
					preaddr: res[0]['presentaddress'],
					peraddr : res[0]['permanentaddress'],
					dob : res[0]['dob'],
					mob : res[0]['mobile'],
					licno : res[0]['licenseno']
				});
			}
		});
	}
	
	/** get Vehicle **/
	getvehicleno(){
		
		GetData('transport/getvehicle').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					vehi : responseJson
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/transport/driver' />);
	}
	
	var veh = this.state.vehi;
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="vehform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Driver</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Vehicle No <span className="text-danger">*</span></Label>
							  <select name="vno" onChange={this.onChange} className="form-control" required value={this.state.vno}>
								<option value="">Select</option>
								{
									veh.map(function (item) {
										return <option value={item.id }>{item.vehicleno}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="dname" required onChange={this.onChange} value={this.state.dname} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Present Address <span className="text-danger">*</span></Label>
							  <Input type="textarea" name="preaddr" required onChange={this.onChange} value={this.state.preaddr} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Permanent Address <span className="text-danger">*</span></Label>
							  <Input type="textarea" name="peraddr" required onChange={this.onChange} value={this.state.peraddr} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Date of Birth <span className="text-danger">*</span></Label>
							  <Input type="date" name="dob" required onChange={this.onChange} value={this.state.dob} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Mobile <span className="text-danger">*</span></Label>
							  <Input type="text" name="mob" required onChange={this.onChange} value={this.state.mob} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">License No <span className="text-danger">*</span></Label>
							  <Input type="text" name="licno" required onChange={this.onChange} value={this.state.licno} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EditDriver;


// WEBPACK FOOTER //
// ./src/transport/Driver/EditDriver.js